import { IBrowseState } from "../models";
import { BrowseActionTypes } from "../models/browseActions";
import {
    CHANGE_SORT,
    GET_RESULTS_REQUEST,
    GET_RESULTS_SUCCESS,
    GET_RESULTS_FAILURE,
    SET_SEARCH,
    SET_PAGE,
    SET_FILTERS,
    CLEAR_FILTERS,
    TOGGLE_FILTER_CATEGORY
 } from "../types";

 const isServer = !process.env.WEBPACK;
 const isAdsEnabled = !isServer && window.isAdsEnabled === 1;

const initialState: IBrowseState = {
    plans: [],
    sorting: "time",
    filters: [],
    search: "",
    page: 1,
    totalPages: 1,
    limit: isAdsEnabled ? 10 : 12,
    totalDocs: 0,
    loading: true,
    error: false,
    timeTaken: 0,
    filterCategories: {
        opus: true,
        rhythm: false,
        pitch: false,
    }
};

export default (state: IBrowseState = initialState, action: BrowseActionTypes): IBrowseState => {
    switch (action.type) {
        case GET_RESULTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case GET_RESULTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
            }
        case GET_RESULTS_SUCCESS:
            return {
                ...state,
                plans: action.payload.plans,
                totalPages: action.payload.totalPages,
                totalDocs: action.payload.totalDocs,
                timeTaken: action.payload.timeTaken,
                loading: false,
            }
        case CHANGE_SORT:
            return {
                ...state,
                page: 1,
                sorting: action.payload,
            }
        case SET_SEARCH:
            return {
                ...state,
                search: action.payload,
                page: 1,
            }
        case SET_PAGE:
            return {
                ...state,
                page: action.payload,
            }
        case SET_FILTERS:
            return {
                ...state,
                filters: action.payload,
                page: 1,
            }
        case CLEAR_FILTERS:
            return {
                ...state,
                filters: [],
                page: 1,
            }
        case TOGGLE_FILTER_CATEGORY:
            return {
                ...state,
                filterCategories: {
                    ...state.filterCategories,
                    [action.payload]: !state.filterCategories[action.payload]
                }
            }
        default:
            return state;
    }
};

